const MAPA_COTACAO_ZOOM_STORAGE_KEY = "mapaCotacaoZoom";
const MAPA_COTACAO_ZOOM_MIN = 70;
const MAPA_COTACAO_ZOOM_MAX = 120;
const MAPA_COTACAO_ZOOM_STEP = 10;
const MAPA_COTACAO_ZOOM_DEFAULT = 100;

export default {
  data() {
    return {
      mapaCotacaoZoom: MAPA_COTACAO_ZOOM_DEFAULT,
      mapaCotacaoZoomMin: MAPA_COTACAO_ZOOM_MIN,
      mapaCotacaoZoomMax: MAPA_COTACAO_ZOOM_MAX,
      mapaCotacaoZoomDefault: MAPA_COTACAO_ZOOM_DEFAULT,
    };
  },
  computed: {
    mapaCotacaoZoomClass() {
      return `mapa-zoom-${this.mapaCotacaoZoom}`;
    },
  },
  created() {
    this.carregarMapaCotacaoZoom();
  },
  methods: {
    carregarMapaCotacaoZoom() {
      const zoomSalvo = Number(localStorage.getItem(MAPA_COTACAO_ZOOM_STORAGE_KEY));

      if (this.zoomMapaEhValido(zoomSalvo)) {
        this.mapaCotacaoZoom = zoomSalvo;
      }
    },
    aumentarZoomMapa() {
      this.definirZoomMapa(this.mapaCotacaoZoom + MAPA_COTACAO_ZOOM_STEP);
    },
    diminuirZoomMapa() {
      this.definirZoomMapa(this.mapaCotacaoZoom - MAPA_COTACAO_ZOOM_STEP);
    },
    restaurarZoomMapa() {
      this.definirZoomMapa(MAPA_COTACAO_ZOOM_DEFAULT);
    },
    definirZoomMapa(valor) {
      const zoom = Math.min(
        MAPA_COTACAO_ZOOM_MAX,
        Math.max(MAPA_COTACAO_ZOOM_MIN, Number(valor))
      );

      if (!this.zoomMapaEhValido(zoom)) {
        return;
      }

      this.mapaCotacaoZoom = zoom;
      localStorage.setItem(MAPA_COTACAO_ZOOM_STORAGE_KEY, String(zoom));
    },
    zoomMapaEhValido(valor) {
      return (
        Number.isInteger(valor) &&
        valor >= MAPA_COTACAO_ZOOM_MIN &&
        valor <= MAPA_COTACAO_ZOOM_MAX &&
        valor % MAPA_COTACAO_ZOOM_STEP === 0
      );
    },
  },
};
